// extracted by mini-css-extract-plugin
export var icon = "_5i-1";
export var subtext = "_5i-0";